import React, { useContext } from "react";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import TenantLogo from "../common/TenantLogo";

interface IParams {
  tenant: ITenant;
}

const SidebarLogo: React.FC<IParams> = ({ tenant }) => {
  const rootStore = useContext(RootStoreContext);
  const { isOfflineModeEnabled } = rootStore.commonStore;

  return (
    <div className="sidebar-logo">
      <a href={isOfflineModeEnabled ? "/player/offline" : "/"}>
        <TenantLogo tenant={tenant} sidebarLogo={true} className="w-100" />
      </a>
      {/* <span className="small">{process.env.REACT_APP_VERSION && `V ${process.env.REACT_APP_VERSION}` }</span> */}
    </div>
  );
};

export default SidebarLogo;
